import ButtonCellValue from "./ButtonCellValue";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Value", ButtonCellValue);
